module.exports = __webpack_public_path__ + "static/media/aws_badge.23124328.png";